import { render } from "./_CoachCard.vue?vue&type=template&id=a552adfc"
import script from "./_CoachCard.vue?vue&type=script&lang=js"
export * from "./_CoachCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/musora-web-platform/musora-web-platform/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__